import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { geosApi } from '@/api/index';

export const fetchGeos = createAsyncThunk(
  'geos',
  async (params, thunkAPI) => {
    try {
      const response = await geosApi.getAll();
      if (response) {
        const upgradedData = await Promise.all(response.data.map((geo) => geosApi.getOneById(geo.id)));
        if (upgradedData) {
          return upgradedData.map((elem) => elem?.data);
        }
      }
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
    return undefined;
  },
);
